<template>
  <v-card>
    <GenericListTable
      :parentID="this.parentID"
      :title="`Device Types`"
      :headers="[
          { text: 'ID', value: 'id' },
          { text: 'Device Type Name', value: 'typename' },
          { text: 'Device Type Description', value: 'description' }
        ]"
      :url="`/schemas/devicetypes`"
      :apiResponseField="`devicetypes`"
      :onClickRoute="`DeviceTypeSingle`"
      :onClickParams="getOnClickParams">
    </GenericListTable>
  </v-card>
</template>

<script>
import GenericListTable from '@/components/Common/GenericListTable'

export default {
  name: 'DeviceTypeListTable',
  components: { GenericListTable },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  methods: {
    getOnClickParams (item) {
      return {
        id: item.id
      }
    }
  }
}
</script>
